module.exports = __webpack_public_path__ + "static/media/about.f0ca1e10.md";


//////////////////
// WEBPACK FOOTER
// ./src/app/data/about.md
// module id = 169
// module chunks = 0